import { render, staticRenderFns } from "./BundleUpdateNewMember.vue?vue&type=template&id=35f82cc9"
import script from "./BundleUpdateNewMember.vue?vue&type=script&lang=js"
export * from "./BundleUpdateNewMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports